export default {
  path: "/admin_tools",
  name: "admin_tools",
  component: {
    template: `<router-view></router-view>`
  },
  children: [
    {
      path: "change_roles",
      name: "admin_tools/change_roles",
      component: () => import("@/components/AdminTools/ChangeRoles"),
      meta: {
        can: "admin::role"
      }
    },
    {
      path: "get_sms_code",
      name: "admin_tools/get_sms_code",
      component: () => import("@/components/AdminTools/GetSMSCode"),
      meta: {
        can: "admin::admin-tools:get-sms-code"
      }
    },
    {
      path: "edit_menu",
      name: "admin_tools/edit_menu",
      component: () => import("@/components/AdminTools/EditMenu"),
      meta: {
        can: "admin::menu"
      }
    },
    {
      path: "edit_permissions",
      name: "admin_tools/edit_permissions",
      component: () => import("@/components/AdminTools/EditPermissions"),
      meta: {
        can: "admin::role:permissions"
      }
    },
    {
      path: "password_change",
      name: "admin_tools/password_change",
      component: () => import("@/components/AdminTools/PasswordChange"),
      meta: {
        can: "admin::customer:password"
      }
    },
    {
      path: "staff",
      name: "admin_tools/staff",
      component: () => import("@/components/AdminTools/Staff"),
      meta: {
        can: "admin::admin-tools:staff"
      }
    },{
    path: "permissions",
    name: "admin_tools/permissions",
    component: () => import("@/components/AdminTools/Abilities"),
    meta: {
      can: "admin::admin-tools:permissions"
    }
  }
  ]
};



// WEBPACK FOOTER //
// ./src/router/admin-tools.js